import React from 'react';
import './ServicePages.css';

const GenAiPage = ({ onContactClick }) => {
  const features = [
    { icon: "✍️", title: "Content Generation", desc: "Produce marketing copy, blog posts, product descriptions, and social media content at scale." },
    { icon: "💻", title: "Code Co-Pilots", desc: "AI-powered coding assistants that write, review, and debug code alongside your engineering team." },
    { icon: "🎨", title: "Image & Design Generation", desc: "Create stunning visuals, UI mockups, and brand assets using state-of-the-art diffusion models." },
    { icon: "🧬", title: "Synthetic Data", desc: "Generate realistic synthetic datasets for training ML models without privacy concerns." },
    { icon: "🔧", title: "Custom Model Fine-Tuning", desc: "Fine-tune foundation models on your proprietary data for domain-specific excellence." },
    { icon: "📈", title: "Productivity Automation", desc: "Automate repetitive knowledge work — emails, reports, summaries, and data entry." }
  ];

  return (
    <div className="service-page theme-genai">
      <section className="svc-hero">
        <div className="svc-hero-content">
          <h1 className="svc-hero-title">Generative<br/>AI</h1>
          <p className="svc-hero-subtitle">CUSTOM LLMS, CONTENT GENERATION & CREATIVE AI.</p>
          <p className="svc-hero-desc">Leverage the frontier of AI to generate content, code, and designs. We fine-tune generative models for your enterprise needs.</p>
          <div className="svc-hero-stats">
            <div className="svc-stat-item"><h3>10x</h3><p>Content Output</p></div>
            <div className="svc-stat-item"><h3>85%</h3><p>Time Saved</p></div>
            <div className="svc-stat-item"><h3>50+</h3><p>Models Deployed</p></div>
          </div>
          <div className="svc-hero-cta">
            <button className="svc-btn-primary" onClick={onContactClick}>Book a Call</button>
            <button className="svc-btn-secondary"><span>▶</span> See Demo</button>
          </div>
        </div>
        <div className="svc-hero-visual">
          <div className="svc-glowing-ring">🎨</div>
        </div>
      </section>

      <section className="svc-features-section">
        <h2 className="svc-section-title">Generative AI Solutions</h2>
        <div className="svc-features-grid">
          {features.map((f, i) => (
            <div key={i} className="svc-feature-card">
              <div className="feature-icon">{f.icon}</div>
              <h3 className="feature-title">{f.title}</h3>
              <p className="feature-desc">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="svc-cta-section">
        <div className="svc-cta-content">
          <h2>Ready to unlock creative AI?</h2>
          <p>Book a call and we'll explore how generative AI can transform your workflows.</p>
          <button className="svc-btn-cta" onClick={onContactClick}>Book a Call</button>
        </div>
      </section>
    </div>
  );
};

export default GenAiPage;
